import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { NavLink } from 'react-router-dom';
import './DashboardBreadcrumb.css';

const propTypes = {
  client: PropTypes.object,
  quote: PropTypes.object,
};

class DashboardBreadcrumb extends PureComponent {
  render() {
    const { client, policy, quote } = this.props;
    const fullName = `${get(client, 'person.first_name')} ${get(
      client,
      'person.last_name'
    )}`;

    return (
      <ol className="ClientDetailsView-breadcrumb breadcrumb bg-master-light">
        <div className="container-fluid">
          <li className="breadcrumb-item">
            <NavLink
              to="/dashboard/clients"
              className="bold"
              activeClassName="active"
              exact
            >
              Clients
            </NavLink>
          </li>
          {client && (
            <li className="breadcrumb-item text-uppercase">
              <NavLink
                to={`/dashboard/clients/${client.id}`}
                className="bold"
                activeClassName="active"
                exact
              >
                {client.client_type === 'business'
                  ? client.person.company_name
                  : fullName}
              </NavLink>
            </li>
          )}
          {quote && (
            <li className="breadcrumb-item text-uppercase">
              <NavLink
                to={`/dashboard/clients/${client.id}/quotes/${quote.quote_number}`}
                className="bold"
                activeClassName="active"
              >
                Manual Enrollment
              </NavLink>
            </li>
          )}
          {policy && (
            <li className="breadcrumb-item text-uppercase">
              <NavLink
                to={`/dashboard/clients/${client.id}/policies/${policy.id}`}
                className="bold"
                activeClassName="active"
                exact
              >
                {get(policy, 'plan.settings.plan_title')}
              </NavLink>
            </li>
          )}
        </div>
      </ol>
    );
  }
}

DashboardBreadcrumb.propTypes = propTypes;

export default DashboardBreadcrumb;
